export const isTabActive = () =>
  typeof document !== 'undefined' && document.visibilityState === 'visible' && document.hasFocus();

/**
 * Regra do WhatsApp Web: se a aba nao esta em primeiro plano, SEMPRE notifica —
 * mesmo que a conversa esteja aberta na tela, porque o usuario nao esta olhando
 * pra ela. So suprime quando a aba esta ativa E a mensagem e da conversa aberta.
 *
 * O codigo antigo so comparava "e o chat aberto?", entao quem estava em outro
 * app com a conversa aberta nao recebia nada.
 */
export function shouldNotifyMessage({ chatIdEvento, chatAbertoId } = {}) {
  if (!isTabActive()) return true;
  if (!chatAbertoId) return true;
  return String(chatIdEvento) !== String(chatAbertoId);
}

const mesmoId = (a, b) => a != null && b != null && String(a) === String(b);

/**
 * Decide se uma mensagem individual deve alertar ESTE usuario.
 *
 * O emit de `newMessage` sai com `whoTo: "clienteId"`, ou seja chega para a
 * organizacao inteira — quem filtra e o front. O unico sinal confiavel de
 * "esta conversa e minha" no payload e `scope.usuario_id`, preenchido pelo
 * backend com `chat.direciona_usuarios[0]`.
 *
 * NAO tentar cobrir a fila aqui. Ja foi tentado inferindo o publico a partir
 * das listas locais e de `lista_atualizar`, e o resultado foi notificar todos
 * os agentes por toda conversa: `chatsGeral` vem de
 * `Chats.find({ statusRoom: "Geral", cliente_id })` (chats.controller.js:167),
 * sem nenhum filtro por usuario ou setor — "esta na minha lista" era verdade
 * para a organizacao inteira.
 *
 * Cliente em espera tem dois caminhos proprios, corretamente enderecados pelo
 * backend: `newChatToUser` (resolve setor -> usuarios e manda `scope.userIds`)
 * e o alerta por aumento de `count_pendente`, cuja query filtra por usuario +
 * setor.
 */
export function isEventoRelevante({ envelope = {}, scope = {}, user = {} } = {}) {
  const enderecado =
    !envelope.whoTo ||
    envelope.whoTo === 'clienteId' ||
    (envelope.whoTo === 'usuarioId' && mesmoId(envelope.to, user.id));
  if (!enderecado) return false;

  // Sem dono definido nao da para saber de quem e a conversa: nao alerta.
  // `user.level === 'root'` tambem nao entra aqui — root passaria a receber
  // todas as mensagens da organizacao.
  return mesmoId(scope.usuario_id, user.id);
}
